"use client";

import React, { createContext, useContext, ReactNode } from 'react';
import { useColorMode } from '@chakra-ui/react';

interface ColorModeContextType {
    isDarkMode: boolean;
    toggleColorMode: () => void;
}

const ColorModeContext = createContext<ColorModeContextType | undefined>(undefined);

export const ColorModeProvider = ({ children }: { children: ReactNode }) => {
    const { colorMode, toggleColorMode } = useColorMode();
    const isDarkMode = colorMode === 'dark';

    return (
        <ColorModeContext.Provider value={{ isDarkMode, toggleColorMode }}>
            {children}
        </ColorModeContext.Provider>
    );
};

export const useColorModeContext = () => {
    const context = useContext(ColorModeContext);
    if (!context) {
        throw new Error('useColorModeContext must be used within a ColorModeProvider');
    }
    return context;
}; 